import React, { useState } from "react";
import "./approvals.css";
import { Button, Card, Table } from "antd";
import { InfoCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../utils/axiosInterceptor";
import { useNavigate } from "react-router-dom";
import AutomationExceptionFile from "../../../components/automationExceptionFile/AutomationExceptionFile";
const Approvals = ({
  setActiveMenu,
  setRebateData,
  // rebateData,
  loading,
  // cogsData,
  allUploadFiles,
  getAllUploadedFiles
}) => {
  const [selected, setSelected] = useState(1);
  const [cogsPending, setCogsPending] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  const [file, setFile] = useState("");
  const [selectedFileData, setSelectedFileData] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [fileData, setFileData] = useState("");

  const rebateData = allUploadFiles.filter(
        (item) => item.FileType === "Rebate"
      )
  const cogsData = allUploadFiles.filter(
        (item) => item.FileType === "COGS"
      )

  const getRebatFile = async (data) => {
    if (!data?.FileId && !data?.Id) {
      return;
    }
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        `/automationRouter/rebate-exceptions/${data?.FileId || data?.Id}`
      );
      setSelectedFileData(response?.data);
      setFileData(data);
    } catch (error) {
      console.log(error, "erorrs");
    } finally {
      setIsLoading(false);
    }
  };
  const getSelectedCogsData = async (data) => {
    if (!data?.FileId && !data?.Id) {
      return;
    }
    setFileData(data);
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        `/automationRouter/exceptionsCOGS/${data?.FileId || data?.Id}`
      );
      setSelectedFileData(response?.data?.exceptions);
    } catch (error) {
      console.log(error, "erorrs");
    } finally {
      setIsLoading(false);
    }
  };
  const Column = [
    {
      title: "File Name",
      dataIndex: "FileName",
      key: "FileName",
      sorter: true,
    },
    {
      title: "Upload By",
      dataIndex: "UploadedBy",
      key: "UploadedBy",
      sorter: true,
    },
    {
      title: "Upload Time",
      dataIndex: "UploadedAt",
      key: "UploadedAt",
      render: (text) => {
        const date = new Date(text);
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month (1–12)
        const day = String(date.getDate()).padStart(2, "0"); // Day (1–31)
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      },
    },
    {
      title: "File Type",
      dataIndex: "FileType",
      key: "FileType",
      sorter: true,
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      sorter: true,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <div className="flex gap-2">
            <Button
              // onClick={() =>
              //   navigate("/automation-audit-log", {
              //     state: { data: record, from :"rebate" },
              //   })
              // }
              onClick={() => {
                setFile(record.FileType);
                setModalVisible(true);
                getRebatFile(record);
              }}
            >
              View
            </Button>
          </div>
        );
      },
    },
  ];
  const CogsColumn = [
    {
      title: "File Name",
      dataIndex: "FileName",
      key: "FileName",
    },
    {
      title: "Upload By",
      dataIndex: "UploadedBy",
      key: "UploadedBy",
    },
    {
      title: "Upload Time",
      dataIndex: "UploadedAt",
      key: "UploadedAt",
      render: (text) => {
        const date = new Date(text);
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month (1–12)
        const day = String(date.getDate()).padStart(2, "0"); // Day (1–31)
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      },
    },
    {
      title: "File Type",
      dataIndex: "FileType",
      key: "FileType",
      sorter: true,
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <div className="flex gap-2">
            <Button
              // onClick={() =>
              //   navigate("/automation-audit-log", {
              //     state: { data: record, from:'cogs' },
              //   })
              // }
              onClick={() => {
                setFile(record.FileType);
                setModalVisible(true);
                getSelectedCogsData(record);
              }}
            >
              View
            </Button>
          </div>
        );
      },
    },
  ];
  return (
    <div>
      <Card
        title={
          <div className="flex justify-between items-center">
            <span className="font-semibold text-[16px] leading-[100%] tracking-[0%] text-justify text-[#000833]">
              Approvals
            </span>
            <div className="flex items-center gap-4">
              <div className="-mr-1">
                <InfoCircleOutlined className="mr-2" />
                <MoreOutlined />
              </div>
            </div>
          </div>
        }
      >
        <div>
          <span className="cardtitle mt-20 ">Files Awaiting Approval</span>
        </div>
        <div className="mt-7">
          <span style={{ fontSize: 18, fontWeight: "600", color: "#000833" }}>
            Rebate Exception
          </span>
        </div>

        <div className="titles w-[70%] md:w-[20%] items-center mt-2 ml-2">
          <span
            onClick={() => setSelected(1)}
            style={
              selected === 1
                ? {
                    color: "#000833",
                    fontWeight: "600",
                    fontSize: 17,
                  }
                : {}
            }
          >
            Pending
          </span>
          <span
            onClick={() => setSelected(2)}
            style={
              selected === 2
                ? {
                    color: "#000833",
                    fontWeight: "600",
                    fontSize: 17,
                  }
                : {}
            }
          >
            Approved
          </span>
        </div>

        {/* {selected === 1 ? ( */}
        <div className="mt-2">
          <Table
            columns={Column}
            dataSource={
              selected == 1
                ? rebateData?.filter(
                    (item) =>
                      item.Status === "Uploaded" || item.Status === "Audited"
                  ) || rebateData?.filter((item) => item.Status === "Audited")
                : rebateData.filter((item) => item.Status === "Completed")
            }
            //   pagination={pagination}
            //   onChange={handleTableChange}
            loading={loading}
            scroll={{ x: "max-content" }}
            rowKey="id"
            size="middle"
            className="custom-table user-tbl"
            pagination={false}
          />
        </div>
        <div className="mt-7">
          <span style={{ fontSize: 18, fontWeight: "600", color: "#000833" }}>
            COGS Exception
          </span>
        </div>

        <div className="titles w-[70%] md:w-[20%] items-center mt-2 ml-2">
          <span
            onClick={() => setCogsPending(1)}
            style={
              cogsPending === 1
                ? {
                    color: "#000833",
                    fontWeight: "600",
                    fontSize: 17,
                  }
                : {}
            }
          >
            Pending
          </span>
          <span
            onClick={() => setCogsPending(2)}
            style={
              cogsPending === 2
                ? {
                    color: "#000833",
                    fontWeight: "600",
                    fontSize: 17,
                  }
                : {}
            }
          >
            Approved
          </span>
        </div>

        {cogsPending === 1 ? (
          <div className="mt-2">
            <Table
              columns={CogsColumn}
              dataSource={cogsData?.filter(
                (item) =>
                  item.Status === "Audited" || item.Status === "Uploaded"
              )}
              //   pagination={pagination}
              //   onChange={handleTableChange}
              loading={loading}
              scroll={{ x: "max-content" }}
              rowKey="id"
              size="middle"
              className="custom-table user-tbl"
              pagination={false}
            />
          </div>
        ) : (
          <div className="mt-2">
            <Table
              columns={CogsColumn}
              dataSource={cogsData?.filter(
                (item) => item.Status === "Completed"
              )}
              //   pagination={pagination}
              //   onChange={handleTableChange}
              //   loading={loading}
              scroll={{ x: "max-content" }}
              rowKey="id"
              size="middle"
              className="custom-table user-tbl"
              pagination={false}
            />
          </div>
        )}
      </Card>
      <AutomationExceptionFile
        open={modalVisible}
        hide={() => setModalVisible(false)}
        fileType={file}
        selectedFileData={selectedFileData}
        isLoading={isloading}
        getSelectedCogsData={getSelectedCogsData}
        getRebatFile={getRebatFile}
        fileData={fileData}
        getAllUploadedFiles={getAllUploadedFiles}
      />
    </div>
  );
};
export default Approvals;
